module.exports = function intersection(a, b) {
    var ii = a.length,
        ans = 0;
    for (var i = 0; i < ii ; i++) {
        ans += Math.min(a[i], b[i]);
    }
    return 1 - ans;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/intersection.js
 ** module id = 76
 ** module chunks = 0
 **/